<div class="animated fadeIn backend">
    <div class="row">
        <div class="col-12">
            <div class="top-header-area">
                <div class="header-area">
                    <h3>Customers</h3>
                </div>
                <form class="button-area" (ngSubmit)="filterUpdated()">
                    <div class="input-group search">
                        <input type="text"
                               name="search"
                               class="form-control"
                               placeholder="Search by name or certificate ID"
                               aria-label="Search..."
                               [(ngModel)]="searchText"
                               aria-describedby="basic-addon2">
                        <div class="input-group-append">
                            <button class="btn" type="submit"><i class="icon-magnifier"></i></button>
                        </div>
                    </div>

                    <div class="form-inline">
                        <label for="name">Items per page</label>
                        <select class="form-control custom-select" 
                            name="customerType" [(ngModel)]="pageSize" (ngModelChange)="updatePageSize()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>

                    <button type="button" class="btn btn-primary" [routerLink]="['/admin', 'customers', 'new']">
                        <i class="icon-plus icons"></i> Add
                    </button>
                </form>
            </div>
        </div>
        <div class="col-12">
            <perfect-scrollbar class="table-area"  [config]="scrollConfig">
                <table class="table table-hover customer">
                    <thead class="thead-light">
                    <tr>
                        <th *ngFor="let col of columns" [class.sorting]="col.canSort"
                            [class.acs]="sortColumn === col && sortAsc"
                            [class.dcs]="sortColumn === col && !sortAsc"
                            [class.text-right]="col.textRight" (click)="sort(col)">{{col.title}}
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let customer of pageCustomers">
                        <td>{{customer.code}}</td>
                        <td>
                            <a [routerLink]="['/admin', 'customers', customer.id]">{{customer.name}}</a>
                        </td>
                        <td>{{customer.customerType | customerType}}</td>
                        <td>{{customer.country}}</td>
                        <td><img *ngIf="customer.logo" [src]="customer.logo.originalUrl"/></td>
                        <td class="table-button">
                            <a class="edit"
                            [routerLink]="['/admin', 'customers', customer.id]"
                            title="Edit"><i class="icon-note"></i></a>
                            <a class="delete" (click)="showDeleteConfirmModal(customer)" title="Delete"><i class="icon-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>
            <div class="no-data" *ngIf="filteredCustomers.length == 0">
                <h2><i class="icon-layers"></i></h2>
                <h3>The list is empty.</h3>
            </div>
            
            <pagination [itemsPerPage]="pageSize" [style.display]="filteredCustomers.length > 0 ? 'block' : 'none'"
                        [totalItems]="filteredCustomers.length"
                        [(ngModel)]="page"
                        (pageChanged)="pageChange($event.page)"></pagination>

        </div>
    </div>
</div>

<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>
